import React from 'react';

import pluralize from 'rebook/apps/utils/text/pluralize';


const PeriodView = ({ date }) => {
  if (date.rentDays) {
    return (<div>{date.rentDays}&nbsp;{pluralize(date.rentDays, 'день', 'дня', 'дней')}</div>);
  }
  return (
    <React.Fragment>
      {date.days
        ? <div>{date.days}&nbsp;{pluralize(date.days, 'день', 'дня', 'дней')}</div>
        : <div>{date.month}&nbsp;{pluralize(date.month, 'месяц', 'месяца', 'месяцев')}</div>}
    </React.Fragment>
  );
};


export default PeriodView;
